import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import "./shared/css/shared.css";
import "./shared/css/pageList.css";
import "./shared/css/filterModal.css";

//components
import Navbar from "./shared/navbar/navbar";
import Message from "./shared/components/FlashMessage/Message";
import Breadcrumb from "./shared/components/Breadcrumb/Breadcrumb";

/* private pages */
import PrivateRoute from "./shared/privateRoute/PrivateRoute";

//pages
import Login from "./pages/auth/pages/Login";
import Register from "./pages/auth/pages/Register";
import Home from "./pages/home/Home";

//client
import Client from "./pages/client/Client";
import MyClient from "./pages/client/MyClient";

//providers
import Provider from "./pages/provider/Provider";

//cloth
import Cloth from "./pages/cloth/Cloth";
import Aviamento from "./pages/aviamento/Aviamento";
import StockGeneral from "./pages/stockGeneral/StockGeneral";

//commission
import Commission from "./pages/Commission/Commission";
//additive
import Additive from "./pages/Additive/Additive";
//product
import NewProduct from "./pages/product/NewProduct";
import Product from "./pages/product/Product";
import SimpleProduct from "./pages/SimpleProduct/SimpleProduct"
//accessory
import Accessory from "./pages/accessory/Accessory";
import NewAccessory from "./pages/accessory/NewAccessory";
import EditAccessory from "./pages/accessory/EditAccessory";

//color
import Color from "./pages/color/Color";
import NewColor from "./pages/color/NewColor";
import EditColor from "./pages/color/EditColor";
import ColorProviderReport from "./pages/color/report/ColorProviderReport";
import ColorType from "./pages/colorType/ColorType";
//budget
import ProposalPDF from "./pages/budget/ProposalPDF/ProposalPDF"
import Budget from "./pages/budget/Budget";
import MyBudget from "./pages/budget/MyBudget";

import Order from "./pages/order/Order";
import MyOrder from "./pages/order/MyOrder";
import OrderReport from "./pages/order/Report/OrderReport";
import OrderProductionTreePage from "./pages/order/ProductionTree/OrderProductionTreePage";
import OrderMarginReport from "./pages/order/Margin/OrderMarginReport";

//stock
import Stock from "./pages/stock/Stock";

//purchase
import Purchase from "./pages/purchase/Purchase";

//production
import Production from "./pages/production/Production";
import Cut from "./pages/production/Cut";
import Sewing from "./pages/production/Sewing";
import Finishing from "./pages/production/Finishing";
import Inspection from "./pages/production/Inspection";
import Shipping from "./pages/production/Shipping";
import ExternalFaction from "./pages/production/ExternalFaction";

//finance
import Payable from "./pages/finance/Payable";
import Receivable from "./pages/finance/Receivable";
import FinanceCategories from "./pages/finance/Categories";
import RecurringTemplates from "./pages/finance/RecurringTemplates";
import CashFlow from "./pages/finance/CashFlow";
import FinanceReport from "./pages/finance/Report";

//fiscal
import Fiscal from "./pages/fiscal/Fiscal";
import FiscalConfig from "./pages/fiscal/FiscalConfig";

import SizeGrid from "./pages/SizeGrid/SizeGrid";
import Category from "./pages/category/Category";

//system user
import ListSystemUser from './pages/system_user/ListSystemUser';
import Backup from "./pages/Backup/Backup"
import ListHistoric from "./pages/Historic/ListHistoric"

/* context */
import { UserProvider } from "./context/UserContext";
import Container from "./shared/container/container";
import Footer from "./shared/footer/footer";

const AUTH_PAGES = ['/login', '/register']

function AppLayout() {
  const location = useLocation()
  const isBarePage = AUTH_PAGES.includes(location.pathname)

  return (
    <>
      {!isBarePage && <Navbar />}
      <div className={isBarePage ? 'page-layout page-layout-full' : 'page-layout'}>
        {!isBarePage && <Breadcrumb />}
        <Message />
        <Container>
          <Routes>
            <Route path="/login" exact element={<Login />} />
            <Route path="/register" exact element={<Register />} />
            <Route path="/" exact element={<Home />} />

            <Route element={<PrivateRoute />}>
              <Route path="/client" exact element={<Client />} />
              <Route path="/myclient" exact element={<MyClient />} />

              <Route path="/product/new" exact element={<NewProduct />} />
              <Route path="/product" exact element={<Product />} />
              <Route path="/simpleProduct" exact element={<SimpleProduct />} />

              <Route path="/category" exact element={<Category />} />

              <Route path="/accessory" exact element={<Accessory />} />
              <Route path="/accessory/new" exact element={<NewAccessory />} />
              <Route
                path="/accessory/edit/:id"
                exact
                element={<EditAccessory />}
              />

              <Route path="/provider" exact element={<Provider />} />

              <Route path="/sizegrid" exact element={<SizeGrid />} />

              <Route path="/cloth" exact element={<Cloth />} />

              <Route path="/aviamento" exact element={<Aviamento />} />

              <Route path="/commission" exact element={<Commission />} />

              <Route path="/additive" exact element={<Additive />} />

              <Route path="/colortype" exact element={<ColorType />} />

              <Route path="/color" exact element={<Color />} />
              <Route path="/color/new" exact element={<NewColor />} />
              <Route path="/color/edit/:id" exact element={<EditColor />} />
              <Route path="/color/report/:providerId" exact element={<ColorProviderReport />} />

              <Route path="/budget/pdf/:id" exact element={<ProposalPDF/> } />

              <Route path="/backup" exact element={<Backup/>} />
              <Route path="/historic/list" exact element={<ListHistoric/>} />

              <Route path="/budget" exact element={<Budget />} />
              <Route path="/mybudget" exact element={<MyBudget />} />

              <Route path="/order" exact element={<Order />} />
              <Route path="/myorder" exact element={<MyOrder />} />
              <Route path="/order/report/:id" exact element={<OrderReport />} />
              <Route path="/order/production-tree/:id" exact element={<OrderProductionTreePage />} />
              <Route path="/order/margin/:id" exact element={<OrderMarginReport />} />

              <Route path="/stock" exact element={<Stock />} />

              <Route path="/stock/general" exact element={<StockGeneral />} />

              <Route path="/purchase" exact element={<Purchase />} />

              <Route path="/production" exact element={<Production />} />
              <Route path="/production/cut" exact element={<Cut />} />
              <Route path="/production/sewing" exact element={<Sewing />} />
              <Route path="/production/finishing" exact element={<Finishing />} />
              <Route path="/production/inspection" exact element={<Inspection />} />
              <Route path="/production/shipping" exact element={<Shipping />} />
              <Route path="/production/external-faction" exact element={<ExternalFaction />} />

              <Route path="/finance/payable" exact element={<Payable />} />
              <Route path="/finance/receivable" exact element={<Receivable />} />
              <Route path="/finance/categories" exact element={<FinanceCategories />} />
              <Route path="/finance/recurring" exact element={<RecurringTemplates />} />
              <Route path="/finance/cashflow" exact element={<CashFlow />} />
              <Route path="/finance/report" exact element={<FinanceReport />} />

              <Route path="/fiscal" exact element={<Fiscal />} />
              <Route path="/fiscal/config" exact element={<FiscalConfig />} />

              <Route path='/system-user/list' exact element={<ListSystemUser />} />
            </Route>
          </Routes>
        </Container>
      </div>
      {!isBarePage && <Footer />}
    </>
  )
}

function App() {
  return (
    <Router>
      <UserProvider>
        <AppLayout />
      </UserProvider>
    </Router>
  );
}

export default App;
